import {
  Grid,
  IconButton,
  TextField,
  LinearProgress,
  Card,
  CardContent,
} from "@mui/material";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import ResponsiveDataGrid from "../../../../components/MobileList/ResponsiveDataGrid";
import { useInlineEditConfig } from "../../../../components/MobileList/inlineEdit";
import contactPersonInlineEdit from "./inlineEdit";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ContactPerson,
  setSearchBody,
} from "../../../../app/slices/contactPersonSlice";
import { BiTrash, BiEdit } from "react-icons/bi";
import ConfirmationDialog from "../../../../helpers/ConfirmationDialog";
import dayjs from "dayjs";

const ContactPersonTable = () => {
  const [search, setSearch] = useState({
    search: "",
  });
  const [pageSize, setPageSize] = useState(15);
  const [currentPage, setCurrentPage] = useState(0);
  const [openConfirm, setConfirmOpen] = useState(false);
  const [dialogData, setDialogData] = useState("");

  const dispatch = useDispatch();

  const _ContactPersons = useSelector(
    (state) => state.contactPerson.contactPersons,
  );
  const loading = useSelector(
    (state) => state.contactPerson.contactPersons.loading,
  );
  const _SearchBody = useSelector((state) => state.contactPerson.searchBody);

  const inlineEdit = useInlineEditConfig(
    contactPersonInlineEdit,
    () => dispatch(ContactPerson.getAll(_SearchBody)),
    [dispatch, _SearchBody],
  );

  const handleDeleteClick = (params) => {
    setConfirmOpen(true);
    setDialogData(params);
  };

  const handleConfirmDelete = () => {
    dispatch(ContactPerson.deleteById(dialogData.id, _SearchBody));
    setConfirmOpen(false);
  };

  const handleCancelDelete = () => {
    setConfirmOpen(false);
  };

  const columns = [
    {
      field: "index",
      headerName: "#",
      flex: 0.3,
      renderCell: (params) =>
        params.api.getRowIndexRelativeToVisibleRows(params.id) +
        1 +
        currentPage * pageSize,
    },
    {
      field: "name",
      headerName: "الاسم",
      flex: 1,
    },
    {
      field: "mobile_1",
      headerName: "الهاتف الأول",
      flex: 1,
    },
    {
      field: "mobile_2",
      headerName: "الهاتف الثاني",
      flex: 1,
      renderCell: (params) => params.row.mobile_2 || "-",
    },
    {
      field: "job_title",
      headerName: "المسمى الوظيفي",
      flex: 1,
      renderCell: (params) => params.row.job_title || "-",
    },
    {
      field: "created_at",
      headerName: "تاريخ الإنشاء",
      flex: 1,
      renderCell: (params) =>
        dayjs(params.row.created_at).format("YYYY-MM-DD / hh:mm a") || "-",
    },
    {
      field: "operations",
      headerName: "العمليات",
      flex: 0.8,
      renderCell: (params) => (
        <>
          <IconButton
            onClick={() => dispatch(ContactPerson.getById(params.row.id))}
          >
            <BiEdit />
          </IconButton>
          <IconButton onClick={() => handleDeleteClick(params.row)}>
            <BiTrash />
          </IconButton>
        </>
      ),
    },
  ];

  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(ContactPerson.getAll(_SearchBody));
    }, 500);
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_SearchBody]);

  useEffect(() => {
    dispatch(
      setSearchBody({
        search: search.search,
        skip: currentPage * pageSize,
        take: pageSize,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageSize, search]);

  return (
    <Card>
      <CardContent>
        <Box>
          <ConfirmationDialog
            open={openConfirm}
            title="تاكيد"
            message="هل انت متاكد من الحذف"
            name={dialogData.name}
            confirmText="حذف"
            cancelText="الغاء"
            onConfirm={handleConfirmDelete}
            onCancel={handleCancelDelete}
          />
        </Box>
        <Grid container rowSpacing={1} columnSpacing={2} mb={2}>
          <Grid item xs={12} md={3}>
            <TextField
              size="small"
              value={search.search}
              onChange={(e) => setSearch({ ...search, search: e.target.value })}
              label="بحث حسب المسمى الوظيفي أو الاسم أو الهاتف"
              fullWidth
            />
          </Grid>
        </Grid>
        <Box sx={{ height: { xs: "auto", md: 500 }, width: "100%" }}>
          <ResponsiveDataGrid
            gridHeight={null}
            rows={_ContactPersons.data ?? []}
            columns={columns}
            pageSize={pageSize}
            page={currentPage}
            rowCount={_ContactPersons.total ?? 0}
            loading={loading}
            rowsPerPageOptions={[15, 25, 50, 100]}
            pagination
            paginationMode="server"
            onPageChange={(newPage) => setCurrentPage(newPage)}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            components={{
              LoadingOverlay: LinearProgress,
            }}
            mobile={{ inlineEdit }}
            disableSelectionOnClick
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default ContactPersonTable;
